export default __webpack_public_path__ + "static/media/locations.342d4d2c.svg";